export const ACCORDION_BUTTON_ID_PREFIX = 'accordion-button:';
export const ACCORDION_PANEL_ID_PREFIX = 'accordion-panel:';
